// Cloche des notifications (demandes d'achat, validations de factures…). Rafraîchie toutes les minutes.
import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Box, Button, Divider, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { NotificationsNoneOutlined, NotificationsActiveOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const quand = (d) => {
  const min = Math.round((Date.now() - new Date(d).getTime()) / 60000);
  if (min < 1) return "à l'instant";
  if (min < 60) return `il y a ${min} min`;
  if (min < 1440) return `il y a ${Math.round(min / 60)} h`;
  return new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
};

const NotificationBell = ({ color = 'inherit', onNavigate, down = false }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({ notifications: [], non_lues: 0 });
  const [anchor, setAnchor] = useState(null);
  const load = useCallback(() => { api.get('/notifications').then((r) => setData(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => { clearInterval(t); window.removeEventListener('focus', onFocus); };
  }, [load]);

  const open = (n) => {
    setAnchor(null);
    if (!n.lu) api.post(`/notifications/${n.id}/lu`).then(load).catch(() => {});
    if (n.lien) { navigate(n.lien); onNavigate?.(); }
  };
  const Icon = data.non_lues ? NotificationsActiveOutlined : NotificationsNoneOutlined;

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton size="small" sx={{ color }} aria-label={`Notifications${data.non_lues ? ` (${data.non_lues} non lues)` : ''}`} onClick={(e) => { setAnchor(e.currentTarget); load(); }}>
          <Badge badgeContent={data.non_lues} color="error" max={99}><Icon fontSize="small" /></Badge>
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} PaperProps={{ sx: { width: 360, maxWidth: 'calc(100vw - 24px)', maxHeight: 480 } }}
        anchorOrigin={down ? { vertical: 'bottom', horizontal: 'right' } : { vertical: 'top', horizontal: 'right' }}
        transformOrigin={down ? { vertical: 'top', horizontal: 'right' } : { vertical: 'bottom', horizontal: 'left' }}>
        <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography sx={{ fontWeight: 600 }}>Notifications</Typography>
          {data.non_lues > 0 && <Button size="small" onClick={() => api.post('/notifications/tout-lu').then(load)}>Tout marquer comme lu</Button>}
        </Box>
        <Divider />
        {data.notifications.length === 0 && <Typography sx={{ px: 2, py: 3, color: 'text.secondary', fontSize: 14, textAlign: 'center' }}>Aucune notification</Typography>}
        {data.notifications.map((n) => (
          <MenuItem key={n.id} onClick={() => open(n)} sx={{ whiteSpace: 'normal', alignItems: 'flex-start', gap: 1, py: 1.1, bgcolor: n.lu ? 'transparent' : 'rgba(53,102,168,.07)' }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', mt: 0.8, flexShrink: 0, bgcolor: n.lu ? 'transparent' : 'error.main' }} />
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: 14, fontWeight: n.lu ? 400 : 600 }}>{n.titre}</Typography>
              {n.message && <Typography sx={{ fontSize: 12.5, color: 'text.secondary' }}>{n.message}</Typography>}
              <Typography sx={{ fontSize: 11.5, color: 'text.secondary', mt: 0.25 }}>{quand(n.created_at)}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default NotificationBell;
